<template>
  <section> 
    <b-row>    
      <b-col>
        <b-card
          style="max-width: 100%">
            <template v-slot:header >
              <div class="header-card text-left">
                Pacientes Agendados  
                <b-button size="sm" @click="getDataGet({route: 'agenda_lista', data: 'agenda del dia'})" variant="outline-primary" style="float:right"> <b-icon scale="1.5" icon="arrow-repeat"></b-icon> Sincronizar</b-button>            
              </div>
            </template>
            <b-row>
              <b-col :md="12" style="margin-top:10px">
                  <sw-tableget
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    :tableOptions="tableGBoptions"
                    name="tableAgenda"
                    route="agenda_lista"
                    dataRoute="agenda del dia"                    
                    >
                    <template v-slot:modal>
                      <sw-modalexamen 
                        v-if="openModal.modal.modal==='examen'"
                        @save="saveForm"
                        >
                      </sw-modalexamen>                      
                      <sw-modalexamendelete
                        v-if="openModal.modal.modal==='Eliminar'"
                        @save="saveForm"
                        >
                      </sw-modalexamendelete>  
                    </template>
                  </sw-tableget>                  
              </b-col>              
            </b-row>            
        </b-card>
      </b-col>
    </b-row>                    
  </section>
</template>
<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwInputs from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwModalexamendelete from '@/components/modals/examendelete.vue'
import SwModalexamen from '@/components/modals/examen.vue'


export default { 
  name: "inventario_listproductos",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
  SwInputs,
  SwSaveform,
  SwTableget,
  SwModalexamendelete ,
  SwModalexamen     
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
</style>
